// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import {
  restCreationHandler,
  restDeletionHandler,
  restDetailsHandler,
  restListHandlerPagination,
  restUpdateHandler,
  restStatusHandler
} from "../../utils/rest/RestClient";
import {
  UserInfoResponseDTO,
  UserListInfoResponseDTO,
  UserSearchRequestDTO,
  UserUpdateRequestDTO,
  UserWorkflowRequestDTO,
  UserCreateRequestDTO
} from "../../api/backend-openapi";

const baseUrl = configuration.backendBaseUrl;
const userManagmentUrl = baseUrl + "/userManagement/";

export const requestGetUsersList = createEffect({
  handler: restListHandlerPagination<
    UserSearchRequestDTO,
    UserListInfoResponseDTO
  >(userManagmentUrl + "search")
});
export const requestGetUser = createEffect({
  handler: restDetailsHandler<UserInfoResponseDTO>(userManagmentUrl)
});
export const requestCreateUser = createEffect({
  handler: restCreationHandler<UserCreateRequestDTO, UserInfoResponseDTO>(
    userManagmentUrl
  )
});
export const requestUpdateUser = createEffect({
  handler: restUpdateHandler<UserUpdateRequestDTO, UserInfoResponseDTO>(
    userManagmentUrl
  )
});
export const requestDeleteUser = createEffect({
  handler: restDeletionHandler<UserInfoResponseDTO>(userManagmentUrl)
});

export const requestStatusUser = createEffect({
  handler: restStatusHandler<UserWorkflowRequestDTO, UserInfoResponseDTO>(
    userManagmentUrl
  )
});
